import Buefy from "buefy";
import Vue from "vue";

Vue.use(Buefy, {
  defaultIconPack: "fas",
  defaultFirstDayOfWeek: 1,
  defaultProgrammaticPromise: true
});
